import { DECREE_FINANCIAL_VIEWTYPES } from '~/decrees/decree-detail/decree-detail.const';
import { DecreeTabType, IDecreeDetailTabContent } from '~/decrees/decree-detail/decree-detail.types';
import { Menu, MenuItem } from '~/ui/detail/detail-action-button/detail-action-buttons.types';
import { DetailHeader } from '~/ui/detail/detail-header/detail-header.types';

export const HEADER_MOCK: DetailHeader = {
  id: '',
  title: 'Test title',
  type: 'Decree',
  location: 'Location',
  publicRef: 'Public ref',
  description: 'Description',
  confidential: false,
  editable: true
};

export const PRIMARY_ACTIONS_MOCK: MenuItem[] = [
  {
    id: '',
    name: 'Publicatie genereren'
  }
];

export const SIDEBAR_MOCK: Menu[] = [
  {
    title: 'Publicaties',
    items: [
      {
        id: '',
        name: 'Publicatie genereren'
      }
    ]
  }
];

export const CONTENT_DECREES_MOCK: IDecreeDetailTabContent<DecreeTabType.DECREES> = {
  items: [
    {
      title: 'Informatie',
      items: [
        {
          title: 'Beknopte samenvatting',
          description:
            'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In id elit leo, sed auctor tortor. Pellentesque condimentum nulla sit amet diam imperdiet suscipit. Praesent molestie feugiat nibh et egestas. Proin vitae mi metus, vulputate lobortis erat. Pellentesque gravida, augue quis commodo cursus, odio nulla varius eros, in suscipit ante dolor a sem. In eros elit, ullamcorper fringilla placerat at, ullamcorper ut dolor. Pellentesque tristique egestas eros tincidunt condimentum. Quisque nec gravida massa. Suspendisse faucibus rhoncus magna at vehicula. Nulla ut sem dui. Vestibulum non lorem purus. Sed consequat tortor nec leo eleifend id consequat massa lacinia. Mauris porta faucibus elementum. Quisque sit amet lobortis ipsum'
        },
        {
          title: 'Behandelend departement en dienst',
          description:
            'Praesent molestie feugiat nibh et egestas. Proin vitae mi metus, vulputate lobortis erat. Pellentesque gravida, augue quis commodo cursus, odio nulla varius eros, in suscipit ante dolor a sem.'
        }
      ]
    },
    {
      title: 'Motivatie',
      items: [
        {
          title: 'Aanleiding en context',
          description:
            'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In id elit leo, sed auctor tortor. Pellentesque condimentum nulla sit amet diam imperdiet suscipit. Praesent molestie feugiat nibh et egestas. Proin vitae mi metus, vulputate lobortis erat. Pellentesque gravida, augue quis commodo cursus, odio nulla varius eros, in suscipit ante dolor a sem. In eros elit, ullamcorper fringilla placerat at, ullamcorper ut dolor. Pellentesque tristique egestas eros tincidunt condimentum. Quisque nec gravida massa. Suspendisse faucibus rhoncus magna at vehicula. Nulla ut sem dui. Vestibulum non lorem purus. Sed consequat tortor nec leo eleifend id consequat massa lacinia. Mauris porta faucibus elementum. Quisque sit amet lobortis ipsum'
        }
      ]
    },
    {
      title: 'Iets anders',
      items: []
    }
  ]
};

export const CONTENT_ATTACHMENTS_MOCK: IDecreeDetailTabContent<DecreeTabType.ATTACHMENTS> = {
  items: [
    {
      title: 'Bijlage 1',
      status: 'In aanvraag',
      comment: 'Dit is de toelichting.'
    },
    {
      title: 'Bijlage 2',
      status: 'In aanvraag',
      comment: 'Dit is de toelichting.'
    },
    {
      title: 'Bijlage 3',
      status: 'In aanvraag',
      comment: 'Dit is de toelichting.'
    }
  ]
};

export const CONTENT_APPROVALS_MOCK: IDecreeDetailTabContent<DecreeTabType.APPROVALS> = {
  items: [
    {
      title: 'Goedkeuringen',
      items: [
        {
          title: 'Item 1',
          status: 'In aanvraag',
          comment: 'Dit is de toelichting.'
        },
        {
          title: 'Item 2',
          status: 'In aanvraag',
          comment: 'Dit is de toelichting.'
        },
        {
          title: 'Item 3',
          status: 'In aanvraag',
          comment: 'Dit is de toelichting.'
        }
      ]
    },
    {
      title: 'Adviezen',
      items: []
    }
  ]
};

export const CONTENT_COMMENTS_MOCK: IDecreeDetailTabContent<DecreeTabType.COMMENTS> = {
  items: [
    {
      title: 'Algemene opmerkingen',
      items: [
        {
          user: 'Tom Declerck',
          timestamp: new Date().toISOString(),
          comment:
            'But he had an approved tolerance for others; sometimes wondering, almost with envy, at the high pressure of spirits involved in their misdeeds; and in any extremity inclined to help rather than to reprove.',
          items: [
            {
              user: 'Lisa van Wemel',
              timestamp: new Date().toISOString(),
              comment:
                'But he had an approved tolerance for others; sometimes wondering, almost with envy, at the high pressure of spirits involved in their misdeeds; and in any extremity inclined to help rather than to reprove.'
            },
            {
              user: 'John Doe',
              timestamp: new Date().toISOString(),
              comment:
                'But he had an approved tolerance for others; sometimes wondering, almost with envy, at the high pressure of spirits involved in their misdeeds; and in any extremity inclined to help rather than to reprove.'
            }
          ]
        }
      ]
    },
    {
      title: 'Juridische grond',
      items: []
    }
  ]
};

export const CONTENT_INFO_MOCK: IDecreeDetailTabContent<DecreeTabType.INFO> = {
  items: [
    {
      title: 'Algemene info',
      items: [
        {
          decreeType: 'Het type besluit',
          entity: 'De entiteit',
          createdAt: 'De datum waarop het besluit is aangemaakt',
          editedAt: 'De laatste datum waarop het besluit is aangepast'
        }
      ]
    },
    {
      title: 'Identificatie',
      items: [
        {
          department: 'Het behandelend departement',
          author: 'De auteur'
        }
      ]
    },
    {
      title: 'Basisgegevens',
      items: []
    }
  ]
};

export const CONTENT_RIGHTS_MOCK: IDecreeDetailTabContent<DecreeTabType.RIGHTS> = {
  items: [
    {
      title: 'Volgende groepen & gebruikers kunnen dit besluit inkijken',
      items: [
        {
          title: 'Administratie',
          items: [
            {
              title: 'Departement 1/Departementshoofd'
            },
            {
              title: 'Departement 1/Dienst 3/Auteur'
            }
          ]
        },
        {
          title: 'Adviesorganen',
          items: [
            {
              title: 'Pers'
            }
          ]
        },
        {
          title: 'Orgaan',
          items: [
            {
              title: 'College van burgemeester en schepenen/Secretariaat'
            }
          ]
        }
      ]
    }
  ]
};

export const CONTENT_FINANCIAL_MOCK: IDecreeDetailTabContent<DecreeTabType.FINANCIAL> = {
  items: [
    {
      title: 'Visum van de financieel beheerder',
      type: DECREE_FINANCIAL_VIEWTYPES.LIST,
      items: [
        {
          status: 'In aanvraag',
          datum: '20/12/2024 09:35',
          motivatie: 'test'
        }
      ]
    },
    {
      title: 'Budgetsleutels',
      type: DECREE_FINANCIAL_VIEWTYPES.TABLE,
      items: [
        {
          jaar: '2024',
          domein: 'Provinciaal beleid',
          doelstelling: 'Limburg ontwikkelen',
          actievolgnummer: '12345',
          ordernummer: '',
          beschikbaar: '€ 25 000,00'
        }
      ]
    },
    {
      title: 'Financiële en beleidsinformatie',
      type: DECREE_FINANCIAL_VIEWTYPES.LIST,
      items: []
    }
  ]
};

export const CONTENT_NOTES_MOCK: IDecreeDetailTabContent<DecreeTabType.NOTES> = {
  items: [
    {
      title: 'Notulen',
      items: [
        {
          description:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
        }
      ]
    },
    {
      title: 'Stemresultaten',
      items: [
        {
          title: 'Stemresultaten voor artikel 1',
          warnings: ['Er werd geen meerderheid gehaald voor deze stemronde'],
          info: ['Stemresultaat: Voor'],
          votes: {
            title: 'Publieke stemming met:',
            listItems: [
              '4 stem(men) voor: schepen 1, schepen 2, schepen 3',
              '2 stem(men) tegen: schepen 5, schepen 6',
              '3 onthoudingen',
              '0 ongeldige stem(men)'
            ]
          }
        },
        {
          title: 'Stemresultaten voor artikel 2',
          warnings: [
            'Er waren niet genoeg stemgerechtigde aanwezig',
            'Er werd geen meerderheid gehaald voor deze stemronde'
          ],
          info: ['Te weerhouden kandidaten: Kandidaat 1, Kandidaat 2, ...'],
          votes: {
            title: 'Publieke stemming met:',
            listItems: [
              '4 stem(men) voor: schepen 1, schepen 2, schepen 3',
              '2 stem(men) tegen: schepen 5, schepen 6',
              '3 onthoudingen',
              '0 ongeldige stem(men)'
            ]
          }
        },
        {
          title: 'Notulen stemresultaten',
          description:
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
        }
      ]
    }
  ]
};

export const CONTENT_WEBCAST_MOCK: IDecreeDetailTabContent<DecreeTabType.WEBCAST> = {
  items: [
    {
      title: 'Webcast',
      items: [
        {
          videoUrl:
            '//sdk.companywebcast.com/sdk/player/?id=greenvalleybelgiumtest_20170725_5&offsets=2017-07-25T07:55:56Z,2017-07-25T07:56:19Z'
        }
      ]
    },
    {
      title: 'Sprekers',
      items: [
        {
          speakers: [
            { name: 'de heer Frans Brood', info: ['Schepen van cultuur', 'Partij X'] },
            { name: 'de heer Peter Selie', info: ['Raadslid', 'Partij Y'] }
          ]
        }
      ]
    }
  ]
};

export const CONTENT_IMPORTED_DECREE_MOCK_1: IDecreeDetailTabContent<DecreeTabType.IMPORTED_DECREE> = {
  id: '1',
  items: [
    {
      title: 'Informatie',
      items: [
        {
          title: 'besluit 1'
        }
      ]
    },
    {
      title: 'Iets anders',
      items: []
    }
  ]
};

export const CONTENT_IMPORTED_DECREE_MOCK_2: IDecreeDetailTabContent<DecreeTabType.IMPORTED_DECREE> = {
  id: '2',
  items: [
    {
      title: 'Informatie',
      items: [
        {
          title: 'besluit 2'
        }
      ]
    },
    {
      title: 'Iets anders',
      items: []
    }
  ]
};
